export default __webpack_public_path__ + "static/media/icon_return.0e18a3e0.svg";